import { Vault } from './v3/Vault';

const BLOCK = 4 * 1024 * 1024;
const store = () => new Vault('incoming-shares');
interface ShareRecord { title: string; text: string; url: string; expires: number; files: { name: string; type: string; size: number; blocks: number }[] }
export interface InboundShare { title: string; text: string; url: string; files: File[] }
/** Extension drafts use the fragment so capture contents are not sent in HTTP URLs. */
export function shareParameters(search: string, hash: string): URLSearchParams {
  return new URLSearchParams(hash.length > 1 ? hash.slice(1) : search);
}
function validID(id: string) { if (!/^[0-9a-f-]{36}$/.test(id)) throw new Error('Ungültige Freigabe.'); }
export async function discardShare(id: string) {
  validID(id); const vault = store(); try { for (const key of await vault.keys(`${id}:`)) await vault.remove(key); } finally { await vault.close(); }
}
export async function expireShares() {
  const vault = store(); try { for (const key of (await vault.keys('')).filter((k) => k.endsWith(':record'))) { const record = await vault.get<ShareRecord>(key); if (!record || record.expires < Date.now()) await discardShare(key.split(':')[0]!); } } finally { await vault.close(); }
}
/** Unauthenticated OS capture: encrypted device-local staging, no API or Cache API. */
export async function receiveShare(form: FormData): Promise<string> {
  await expireShares(); const id = crypto.randomUUID(); const vault = store();
  const files = form.getAll('files').filter((value): value is File => typeof value !== 'string');
  if (files.length > 10 || files.some((file) => file.size > 100 * 1024 * 1024)) throw new Error('Höchstens zehn Dateien mit jeweils 100 MiB.');
  const field = (name: string) => { const value = form.get(name); if (typeof value !== 'string') return ''; if (value.length > 1_000_000) throw new Error('Geteilter Text ist zu groß.'); return value; };
  try {
    const record: ShareRecord = { title: field('title'), text: field('text'), url: field('url'), expires: Date.now() + 86_400_000, files: [] };
    for (const [index, file] of files.entries()) {
      const blocks = Math.max(1, Math.ceil(file.size / BLOCK));
      for (let block = 0; block < blocks; block++) await vault.writeBytes(`${id}:file:${index}:${block}`, await file.slice(block * BLOCK, (block + 1) * BLOCK).arrayBuffer());
      record.files.push({ name: file.name, type: file.type, size: file.size, blocks });
    }
    await vault.set(`${id}:record`, record); return id;
  } catch (error) { await discardShare(id); throw error; } finally { await vault.close(); }
}
export async function loadShare(id: string): Promise<InboundShare> {
  validID(id); const vault = store();
  try {
    const record = await vault.get<ShareRecord>(`${id}:record`); if (!record || record.expires < Date.now()) throw new Error('Diese Freigabe ist nicht mehr verfügbar. Bitte erneut aus der Quell-App teilen.');
    const files: File[] = [];
    for (const [index, item] of record.files.entries()) {
      const parts: ArrayBuffer[] = [];
      for (let block = 0; block < item.blocks; block++) { const bytes = await vault.readBytes(`${id}:file:${index}:${block}`); if (!bytes) throw new Error('Ein geteilter Dateiblock fehlt. Bitte erneut teilen.'); parts.push(bytes); }
      const file = new File(parts, item.name, { type: item.type }); if (file.size !== item.size) throw new Error('Unvollständige Freigabe.'); files.push(file);
    }
    return { title: record.title, text: record.text, url: record.url, files };
  } finally { await vault.close(); }
}
